import moment, { Moment } from "moment";

export const HOURS = Array.from({ length: 12 }, (_, index) => String(index + 1).padStart(2, "0"));
export const INPUT_SEGMENTS = ["hour", "minute", "period"] as const;
export const PERIODS = ["AM", "PM"] as const;

const TIME_VALUE_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

const isTimeValue = (value: null | string | undefined) => TIME_VALUE_PATTERN.test(value ?? "");

export const parseTime = (value: null | string | undefined): Moment | null => {
  if (!isTimeValue(value)) return null;
  return moment(value, "HH:mm");
};

export const formatTime = (date: Moment | null): string | undefined => {
  if (!date?.isValid()) return undefined;
  return date.format("HH:mm");
};
